<template>
  <div class="segment needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="segment.title" text="segment.info" ></Info>
    <div class="title">
      <h3>{{$t('segment.title')}}</h3>
      <div class="yearSelector"> <v-select v-model="year" :options="years" :clearable="false" v-on:change="setRfm()"></v-select></div>
    </div>
    <div class="main-content" :class="{'full': fullscreen}">
      <chartist class="segment-chart" ref="chart" :data="chartData" :options="chartOptions" type="Pie" :event-handlers="eventHandlers"  v-if="chartData.series.length > 0"></chartist>
      <div class="legend">
        <ul class="point-legends" v-if="result && result.aggregations && result.aggregations[rfm]">
          <li v-for="(seg, index) in result.aggregations[rfm].buckets">
            <div :class="getClassPoint(index)"></div>
            <div class="text-legend">
              <div>{{seg.label}}</div>
              <div>{{seg.doc_count | getKNumber | splitNumber}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Segment',
    components: {
      Info
    },
    props: {
      result: Object, 
      nbOfColumns: Number
    },
    watch: {
      result(new_value, old_value) {
        this.refresh()
      }, 
      nbOfColumns() {
        this.refresh()
      }
    },
    data() {
      return {
        fullscreen: false,
        year: '2024-2025',
        years: ['2024-2025', '2023-2024', '2022-2023', '2021-2022','2020-2021', '2019-2020', '2018-2019', '2017-2018', '2016-2017', '2015-2016'],
        rfm: 'rfm2425',
        chartOptions: {
          donut: true,
          donutWidth: 10,
          donutSolid: true,
          startAngle: 0,
          showLabel: false,
        },
        myHeight: 0,
        myWidth: 0, 
        eventHandlers: []
      }
    },
    computed: {
      chartData() {
        let seg = []
        if (this.result && this.result.aggregations && this.result.aggregations[this.rfm]) {
          seg = this.result.aggregations[this.rfm].buckets.map(s => s.doc_count)
        }
        return {series: seg}
      }
    },
    methods: {
      onFullScreen() {
        if(this.myHeight == 0) {
          this.myHeight = document.getElementsByClassName('segment-chart')[0].clientHeight - 4
          this.myWidth = document.getElementsByClassName('segment-chart')[0].clientWidth
          console.log(this.myWidth)
          console.log(this.myHeight)
          console.log(document.getElementsByClassName('segment-chart'))
        }
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          this.chartOptions.width = "40vw"
          this.chartOptions.height = "40vh"
          this.$refs.chart.redraw()
        } else {
          this.chartOptions.width = `${this.myWidth}px`
          this.chartOptions.height = `${this.myHeight}px`
          this.$refs.chart.redraw()
        }
        this.$refs.chart.redraw()
      }, 
      getClassPoint(index) {
        let i = index + 1
        return `point point${i}`
      }, 
      refresh() {
        if (this.$refs.chart) {
          this.$refs.chart.redraw()
        }
      },
      setRfm() {
        let startYear = this.year.substring(2,4)
        let endYear = this.year.substring(7,9)
        this.rfm = 'rfm' + startYear + endYear
      },
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/segment.sass"
</style>
